import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=7223d1b4"
import script from "./Doughnut.vue?vue&type=script&lang=js"
export * from "./Doughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7223d1b4')) {
      api.createRecord('7223d1b4', component.options)
    } else {
      api.reload('7223d1b4', component.options)
    }
    module.hot.accept("./Doughnut.vue?vue&type=template&id=7223d1b4", function () {
      api.rerender('7223d1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Graphics/Doughnut.vue"
export default component.exports